export default class DeleteLocationError extends Error {

}